import React from "react";
import {Button} from "@material-ui/core";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import Grid from "@material-ui/core/Grid";
import {makeStyles} from "@material-ui/core/styles/index";
import {ProGroups} from "./ProGroups";

const useStyles = makeStyles(theme => ({
    root: {
        height: 'auto',
        flexGrow: 1,
        maxWidth: 700,
    },
    search: {
        [theme.breakpoints.down('sm')]: {
            width: '100%'
        },
        [theme.breakpoints.up('md')]: {
            width: '40%'
        }
    },
    actionColumn: {
        maxWidth: 150,
        width: 100
    },
    avatarColumn: {
        maxWidth: 70,
        width: 70
    },
    actionRow: {
        display: 'flex',
        justifyContent: 'flex-end'
    }
}));


export const ProGroupList = (props: any) => {
    const {t} = useTranslation();
    const classes = useStyles();
    const navigate = useNavigate();

    const addGroup = () => {
        navigate(`/pro-guests/groups/add?folderId=${props.folderId}`);
    };

    return (<Grid container spacing={3}>
        <Grid item xs={12} className={classes.actionRow}>
            <Button variant="contained" color="primary" size="medium"
                    onClick={addGroup}>
                {t('ProGuest.Groups.AddBtn')}
            </Button>
        </Grid>
        <ProGroups {...props} />
    </Grid>);
};
